import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEn = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_HANA_WIDGET_ERROR_FETCH_BUTTON_NO_SUGGESTIONS: 'No suggestions',
  LABEL_HANA_WIDGET_ERROR_FETCH_BUTTON_REFRESH: 'Refresh filters',
  LABEL_HANA_ERROR_FETCH_TITLE: 'Error loading data',
  LABEL_HANA_ERROR_FETCH_DESCRIPTION: 'Could not load data',
  LABEL_HANA_ERROR_FETCH_BUTTON: 'Retry',
  HANA_WIDGET_ERROR_FETCH_TITLE: 'Error loading data',
  HANA_WIDGET_ERROR_FETCH_DESCRIPTION: 'Could not load chart data',
  HANA_WIDGET_ERROR_FETCH_BUTTON: 'Retry',
  HANA_WIDGET_INVALID_DATA_FORMAT: 'Invalid data format'
});
export default localeEn;